var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarranty = function SvgWarranty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    clipPath: "url(#warranty_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.606 22.944c-.394.152-.83.152-1.224 0a16.27 16.27 0 0 1-10.44-15.2v-5.1a1.7 1.7 0 0 1 1.701-1.7h18.702a1.7 1.7 0 0 1 1.7 1.7v5.1a16.27 16.27 0 0 1-10.439 15.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.143 6.857-6.857 7.715L6.856 12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warranty_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgWarranty;